import {
  ExportTaskStatuses,
  type ExportTaskStatus,
} from '../enums/ExportTaskStatusEnum'

// One row of the "Filter Options" key-value cell and the progress
// modal's summary rows (e.g. { label: "Purchased Date From",
// value: "2022-01-01", type: "date" }).
export interface ReportExportTaskFilter {
  label: string
  value: string
  type?: 'date' // date-aware rendering in the Filter Options cell
}

// Generated CSV attachment — Download link target.
interface ExportTaskFileRef {
  uuid: string // /api/v3/attachments/{uuid}
  name: string
}

export interface ReportExportTaskConstructor {
  id: number
  uuid: string // DELETE /api/v3/export-tasks/{uuid}/ key
  status: ExportTaskStatus
  filters: ReportExportTaskFilter[]
  file: Nullable<ExportTaskFileRef> // null until status = READY
  index: number // rows built so far
  max: number // total rows
  createdAt: ISODateString // "Date Prepared" column, default sort key
  requestedDate: Nullable<string> // progress modal "Date Requested" ("--" until set)
  isActive: boolean // false after soft-delete; inactive rows are hidden (BHV-037)
}

export class ReportExportTask {
  readonly id: number
  readonly uuid: string
  readonly status: ExportTaskStatus
  readonly filters: ReportExportTaskFilter[]
  readonly file: Nullable<ExportTaskFileRef>
  readonly index: number
  readonly max: number
  readonly createdAt: Date
  readonly requestedDate: Nullable<string>
  readonly isActive: boolean

  constructor(data: ReportExportTaskConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.status = data.status
    this.filters = data.filters
    this.file = data.file
    this.index = data.index
    this.max = data.max
    this.createdAt = new Date(data.createdAt)
    this.requestedDate = data.requestedDate
    this.isActive = data.isActive
  }

  // History Status cell + progress modal state (BHV-032, BHV-036)
  get isPreparing(): boolean {
    return this.status === ExportTaskStatuses.PREPARING
  }

  get isReady(): boolean {
    return this.status === ExportTaskStatuses.READY
  }

  get isFailed(): boolean {
    return this.status === ExportTaskStatuses.FAILED
  }

  // "Completed: 6 / 6 rows ( 100.00% )" progress text (BHV-032)
  get progressPercent(): number {
    return this.max > 0 ? (this.index / this.max) * 100 : 0
  }

  get hasFilters(): boolean {
    return this.filters.length > 0 // "N/A" cell when empty (BHV-036)
  }
}
